export type IntermediariesRole = 'introducer' | 'servicing' | 'vesting'

export class IntermediariesMeta {
    year1Commission?: any = ''
    renewalCommission?: any = ''
    commissionPct?: number = undefined
    isIfamUser = true
    createNewPayee = false
    isLinkNBR = true
    policyNumber = ''

    userSystemOid = '' // this can be oid either from payee table or picoded_sm table, indicated by isIfamUser
    nric = ''
    email = ''
    name = ''
    role: IntermediariesRole = undefined
    oid = ''

    constructor (type: IntermediariesRole) {
      this.role = type
    }
}
